import { PLATFORM_RESOURCE_ID } from '@/config';
import { useResourcePermission } from '@/features/users/api/get-resource-permissions';
import { hasResourcePermissions } from '@/lib/auth';

type useAuthorizationProps = {
  resourceType: string;
};

export const useAuthorization = ({ resourceType }: useAuthorizationProps) => {
  const { data: resourcePermissions, isLoading } = useResourcePermission({
    resourceType: resourceType,
    resourceId: PLATFORM_RESOURCE_ID,
  });

  return {
    hasResourcePermission: (permissions?: string[]) => {
      return hasResourcePermissions(permissions, resourcePermissions);
    },
    isLoading,
    resourcePermissions,
  };
};
